import { createFileRoute } from "@tanstack/react-router";
import MerchCoupons from "../../../../../views/merchandise/Coupons";

export const Route = createFileRoute("/_authenticated/user/merchandising/coupons/$coupon")({
  component: MerchCoupons,
});
